@if (profileImage.profileImageUrl()) {
  <zwi-image-uploader [imageUrl]="profileImage.profileImageUrl()" (uploaded)="upload($event)"></zwi-image-uploader>
}

